import { render, staticRenderFns } from "./NewsFeed.vue?vue&type=template&id=79398c68&scoped=true&"
import script from "./NewsFeed.vue?vue&type=script&lang=ts&"
export * from "./NewsFeed.vue?vue&type=script&lang=ts&"
import style0 from "./NewsFeed.vue?vue&type=style&index=0&id=79398c68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79398c68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
